class SelectedKeyManager {
    private static instance: SelectedKeyManager;
    private selectedKeys: Map<number, string> = new Map();

    private constructor() { }

    public static getInstance(): SelectedKeyManager {
        if (!SelectedKeyManager.instance) {
            SelectedKeyManager.instance = new SelectedKeyManager();
        }
        return SelectedKeyManager.instance;
    }

    public setSelectedKey(courseId: number, selectedKey: string): void {
        this.selectedKeys.set(courseId, selectedKey);
    }

    public getSelectedKey(courseId: number): string | undefined {
        return this.selectedKeys.get(courseId);
    }

    public clearSelectedKey(courseId: number): void {
        this.selectedKeys.delete(courseId);
    }
}

export default SelectedKeyManager.getInstance();